import { render, staticRenderFns } from "./promotionRecommend.vue?vue&type=template&id=608e2bd4&scoped=true&"
import script from "./promotionRecommend.vue?vue&type=script&lang=js&"
export * from "./promotionRecommend.vue?vue&type=script&lang=js&"
import style0 from "./index.scss?vue&type=style&index=0&id=608e2bd4&scoped=true&lang=scss&"
import style1 from "./promotionRecommend.vue?vue&type=style&index=1&id=608e2bd4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608e2bd4",
  null
  
)

export default component.exports